
export default {
  name: 'HappyKidsHomepageSectionBanner',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data() {
    return {
      isActive: true,
      width: 0
    }
  },

  computed: {
    backgroundImg() {
      const styles = []
      if(this.data?.HeadImage?.url) {
        styles.push(
          {
            backgroundImage: `url(${this.data?.HeadImage?.url})`,
          }
        )
      }
      return styles;
    },
    backgroundImgMobile() {
      const styles = []
      if(this.data?.HeadImageMobile?.url) {
        styles.push(
          {
            backgroundImage: `url(${this.data?.HeadImageMobile?.url})`
          }
        )
      }
      return styles;
    },
  },

  methods: {
    setBackgroundColorStyle(colorHex) {
      if(colorHex) {
        return {
          '--bg': `${colorHex}`
        }
      }
      return undefined;
    },
  },
}
